import { getUserEnableHaptics } from '../../../common/users/utils/userPropertyUtils';
import { ImMNCurrentUser } from '../../user/currentUserSelector';

/**
 * Check if haptics is enabled for the current user. Default to true if not set.
 */
export const getIsHapticsEnabled = (currentUser: ImMNCurrentUser): boolean =>
    getUserEnableHaptics(currentUser) !== false;
